import { useMutation } from '@tanstack/react-query';
import FileDownload from 'js-file-download';

import { useToasts } from '../../cdl/Toast/useToasts';
import { exportDemandCalculation } from '../../common/api/clients/demandDefinitions.api';
import { translate } from '../../common/helpers/translate.helper';
import type { DemandDefinitionInput } from '../types/DemandDefinitionInput';

export const useDemandCalculationExport = (customerGroupId?: string, definitionId?: string) => {
    const { addLoadingToast } = useToasts();
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (input: DemandDefinitionInput) => exportDemandCalculation(input, customerGroupId, definitionId),
    });

    const exportToExcel = (input: DemandDefinitionInput, fileName: string) =>
        addLoadingToast(
            () => mutateAsync(input, { onSuccess: (response) => FileDownload(response.data, fileName) }),
            translate('demandDefinition.exportingToExcel'),
            translate('demandDefinition.exportToExcelSuccess'),
            translate('demandDefinition.exportToExcelError')
        );

    return { exportToExcel, isExporting: isPending };
};
